import fetch from "../utils/fetch";

/**
 * 獲取plan 列表
 * http://schedulepost.dev.apphi.com/api/docs/#!/plans/Plans_list
 * @returns {*}
 */
export function list() {
  return fetch.get("plans", {
    params: {
      from: "desktop",
    },
  });
}
